import styled from 'styled-components'

import { breakpoints } from '@/config/layout'
import { ContentGrid } from '@/layout/components/content-layout/ContentLayout.styled'

const TimelineGrid = styled(ContentGrid)<{
  fullscreen?: boolean
}>`
  background-color: ${({ theme }) => theme.Colors.Background.White};

  @media ${breakpoints.s} {
    grid-template-columns: 1fr;
    grid-template-areas: 'content';
  }

  @media ${breakpoints.m} {
    grid-template-columns: ${({ fullscreen }) => (fullscreen ? '1fr' : '1fr 1fr')};
    grid-template-areas: 'content content-detail';
  }
`

const TimelineNativeContainer = styled.div`
  height: 100%;
  width: 100%;
`

export { TimelineGrid, TimelineNativeContainer }
